var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewEntityContainer',{attrs:{"entityName":_vm.entityName,"identifier":_vm.$route.params.unitId,"getMethod":_vm.getUnit,"refreshOnTimestamp":true,"notificationListeners":[_vm.srEventKey],"notificationValidator":_vm.notificationValidator}})}
var staticRenderFns = []

export { render, staticRenderFns }